import { styled } from "@material-ui/core";

export const BorderBody = styled('div')(({theme})=>({
    position: 'relative',
    width: '100%',
    height: '2px',
    backgroundColor: '#ccc',
    borderRadius: '10px',
    overflow: 'hidden'
}))


export const ProgressBar = styled('div')(()=>({
    position: 'absolute',
    height: '100%',
    backgroundColor: '#fff',
    borderRadius: '10px',
    transition: 'width 1s linear'
}))